<app-loading-screen
  [hidden]="!searchService.search_loading && !searchParams?.isLoadingSSO"
  icon="ico-flight"
  [animated]="animated"
>
  <span title i18n="@@flightLoading_title">Just loading your search results</span>
  <div msgOne>
    @if (searchParams?.departLocation) {
      <span i18n="@@flightLoading_from">Flights from</span>
    }
    <span>&nbsp;</span>
    @if (searchParams?.departLocation) {
      {{ searchParams.departLocation['destination'] | titlecase }}
      ({{ searchParams.departLocation['gateway'] }}), {{ searchParams.departLocation['country'] }}
    }
    <span>&nbsp;</span>
    @if (searchParams?.arriveLocation) {
      <span i18n="@@flightLoading_to">to</span>
    }
    <span>&nbsp;</span>
    @if (searchParams?.arriveLocation) {
      {{ searchParams.arriveLocation['destination'] }} ({{
        searchParams.arriveLocation['gateway']
      }}), {{ searchParams.arriveLocation['country'] }}
    }
  </div>
  <span msgTwo i18n="@@flightLoading_msgTqo">Checking for availability</span>
</app-loading-screen>
